import React, { useState } from 'react';
import { Popover, OverlayTrigger } from 'react-bootstrap';
import classes from './PopoverAsTooltip.module.scss';

const PopoverAsTooltip = React.memo(({ children }) => {
  const [show, setShow] = useState(false);

  return (
    <>
      <OverlayTrigger
        show={show}
        placement='auto'
        popperConfig={{
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, -8],
              },
            },
          ],
        }}
        overlay={
          <Popover
            onMouseEnter={() => setShow(true)}
            onMouseLeave={() => setShow(false)}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
            }}
            id='popover_content'>
            <Popover.Body className={classes.popover_body}>
              <div className='animate__animated animate__fadeIn'>
                <span className={classes.popover_content}>{children}</span>
              </div>
            </Popover.Body>
          </Popover>
        }>
        <span>
          <i
            onMouseEnter={() => setShow(true)}
            onMouseLeave={() => setShow(false)}
            className='icon icon__info__gray ms-2'></i>
        </span>
      </OverlayTrigger>
    </>
  );
});

PopoverAsTooltip.displayName = 'PopoverAsTooltip';

export default PopoverAsTooltip;
